// methodType: GET, POST, PUT, DELETE
export const callZohoAPI = async (
  zohoApiPath: string,
  methodType?: string,
  postParams?: object,
): Promise<any> => {
  const urlPrefix =
    zohoApiPath.indexOf('http') === 0 ? '' : 'https://www.zohoapis.com/'

  const fullUrl = urlPrefix + zohoApiPath
  const method = methodType ? methodType.toUpperCase() : 'GET'

  const options: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'API-KEY': 'ud7^3jf(80',
    },
    body: JSON.stringify({
      url: fullUrl,
      method: method,
      data: postParams,
    }),
  }
  const zohoResponse = await fetch(
    'https://www.websiteforge.com/custom/chosen_zoho_api.php',
    options,
  )
  if (!zohoResponse.ok) {
    const text = await zohoResponse.text()
    // Strip HTML to get a readable error message
    const cleanText = text
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .substring(0, 500)
    const err = new Error(`API ${zohoResponse.status}: ${cleanText}`)
    // Attach debug info
    ;(err as any).debug = {
      status: zohoResponse.status,
      url: fullUrl,
      method: method,
      payload: postParams,
      rawResponse: text.substring(0, 1000),
    }
    throw err
  }
  if (zohoResponse.status == 204) {
    // empty result
    return null
  }
  let response: any = {}
  const clonedResponse = zohoResponse.clone()
  try {
    response = await zohoResponse.json()
  } catch (e) {
    const text = await clonedResponse.text()
    throw new Error(
      `Non-JSON response (${zohoResponse.status}): ${text.substring(0, 500)}`,
    )
  }

  // Zoho Creator API returns errors with a "code" field (not "error")
  // Success codes: 3000 (success), 3100/9220 (no records)
  if (response.error) {
    const errorDetail =
      typeof response.error === 'object'
        ? JSON.stringify(response.error)
        : response.error
    const err = new Error(`Zoho Error: ${response.message || errorDetail}`)
    ;(err as any).debug = {
      url: fullUrl,
      method,
      payload: postParams,
      response,
    }
    throw err
  }

  // Check for Creator-specific error codes
  if (
    response.code &&
    response.code !== 3000 &&
    response.code !== 3100 &&
    response.code !== 9220
  ) {
    const err = new Error(
      `Creator Error ${response.code}: ${response.message || JSON.stringify(response)}`,
    )
    ;(err as any).debug = {
      url: fullUrl,
      method,
      payload: postParams,
      response,
    }
    throw err
  }

  return response
}

/**
 * Format a Date object into Zoho CRM's expected datetime format.
 * Zoho CRM expects: YYYY-MM-DDTHH:mm:ss±HH:MM (no milliseconds, with timezone offset)
 * e.g., "2026-02-12T13:00:00-05:00"
 *
 * JavaScript's toISOString() produces "2026-02-12T18:00:00.000Z" which Zoho rejects
 * with INVALID_DATA on datetime fields.
 */
export function formatZohoDateTime(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0')
  const year = date.getFullYear()
  const month = pad(date.getMonth() + 1)
  const day = pad(date.getDate())
  const hours = pad(date.getHours())
  const minutes = pad(date.getMinutes())
  const seconds = pad(date.getSeconds())

  const tzOffset = -date.getTimezoneOffset() // in minutes, positive = ahead of UTC
  const tzSign = tzOffset >= 0 ? '+' : '-'
  const tzHours = pad(Math.floor(Math.abs(tzOffset) / 60))
  const tzMinutes = pad(Math.abs(tzOffset) % 60)

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${tzSign}${tzHours}:${tzMinutes}`
}

/**
 * Format a Date object into Zoho Creator's expected datetime format.
 * Zoho Creator expects: dd-MMM-yyyy HH:mm:ss
 * e.g., "12-Feb-2026 13:00:00"
 *
 * This is DIFFERENT from Zoho CRM's format.
 */
export function formatCreatorDateTime(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0')
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]
  const day = pad(date.getDate())
  const month = months[date.getMonth()]
  const year = date.getFullYear()
  const hours = pad(date.getHours())
  const minutes = pad(date.getMinutes())
  const seconds = pad(date.getSeconds())

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`
}

export const callGPTAPI = async (
    instructions: string,
    prompt: object,
): Promise<string> => {

    const options: RequestInit = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'API-KEY': 'ud7^3jf(80'
        },
        body: JSON.stringify({
            instructions: instructions,
            prompt: prompt
        })
    }
    const zohoResponse = await fetch('https://www.websiteforge.com/custom/chosen_gpt_api.php', options)
    if (!zohoResponse.ok) {
        throw new Error(`GPT API Error: ${zohoResponse.status}`)
    }
    let response: any = {}
    try {
        response = await zohoResponse.json()
    }
    catch (e) {
        throw new Error(`Error parsing response`)
    }
    if (response.error) {
        throw new Error(`Error: ${response.message}`)
    }
    return response.result;
}

